module.exports = __webpack_public_path__ + "static/img/baiduMusic.6e046d31.png";